export default /*html*/ `
<ui-base-button
  class="ui-button"
  *bind:class="buttonClasses"
  *bind:type="type"
  *bind:disabled="disabled ? true : null"
  *ref="button"
>
  <ui-ripple slot="ripple"></ui-ripple>

  <slot slot="icon-start"></slot>

  <slot slot="icon-end"></slot>
</ui-base-button>`;
